import { gql } from 'apollo-angular';

export const MixpanelTrackEventDocument = gql`
  mutation trackEvent($input: MixpanelTrackEventInputGraphql!) {
    trackEvent(input: $input)
  }
`;
